import RemoteWaiting from '@/views/RemoteWaiting/RemoteWaiting.vue';
import { Route } from '../route.model';

const waiting = new Route('/waiting', 'waiting', RemoteWaiting, {
  requiresAuth: true,
  requiresBusiness: true,
  navbar: {
    name: 'Waiting'
  }
});

export { waiting };
export default waiting;
